// extracted by mini-css-extract-plugin
export var moreInfoButton = "styles-module__moreInfoButton___hwBpO";
export var option = "styles-module__option___a9LsU";